// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_SmartSearchBuyPropertyType.proto

export enum ENUM_SmartSearchBuyPropertyType {
  SMART_SEARCH_BUY_PROPERTY_TYPE_UNSPECIFIED = 'SMART_SEARCH_BUY_PROPERTY_TYPE_UNSPECIFIED',
  SMART_SEARCH_BUY_PROPERTY_TYPE_FIRST_TIME_BUYER = 'SMART_SEARCH_BUY_PROPERTY_TYPE_FIRST_TIME_BUYER',
  SMART_SEARCH_BUY_PROPERTY_TYPE_MOVING_HOME = 'SMART_SEARCH_BUY_PROPERTY_TYPE_MOVING_HOME',
  SMART_SEARCH_BUY_PROPERTY_TYPE_SECOND_HOME = 'SMART_SEARCH_BUY_PROPERTY_TYPE_SECOND_HOME',
  SMART_SEARCH_BUY_PROPERTY_TYPE_BUY_TO_LET = 'SMART_SEARCH_BUY_PROPERTY_TYPE_BUY_TO_LET',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
